export const getContactsError = state => state.contacts.error;
export const getNewContact = state => state.contacts.newContact;
export const getContactsLogin = state => state.contacts.login;
export const getIsFetching = state => state.contacts.isFetching;
export const getInvitationScene = state => state.contacts.scene;
